import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "NationalDiploma";

export const getNationalDiplomaApplication = (rrr) =>
  `${baseUrl}/load-national-diploma-application-form?rrr=${rrr}`;

export const addAndUpdateNationalDiplomaApplication = () => `${baseUrl}/add-or-update-national-diploma-application-form`;

export const addAndUpdateNationalDiplomaProgramme = () => `${baseUrl}/add-or-update-national-diploma-application-programme`;

export const addAndUpdateNationalDiplomaEducation = () => `${baseUrl}/add-or-update-national-diploma-application-education`;

export const addAndUpdateNationalDiplomaOlevel = () => `${baseUrl}/add-or-update-national-diploma-application-olevel-details`;

export const getNationalDiplomaReport = (filter) => `${baseUrl}/get-national-diploma-application-report?${generateUrlParams(filter)}`;

export const downloadNationalDiplomaReport = (filter) => `${baseUrl}/download-national-diploma-application-report?${generateUrlParams(filter)}`;

